module.exports = function (number) {
  if (!number) return;
  let numStr = number.toString();
  let parts = numStr.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};
